import { RichText } from '@/components/RichText';
import styles from './index.module.scss';
import { renderRichText, applyLocaleToUrl } from '@/utils/formatters';
import { useRouter } from 'next/router';

const PromotionStoreList = ({ promotionData }) => {
    const { locale } = useRouter()
    const rows = promotionData?.rows;
    const cta = promotionData?.cta?.fields;
    const firstRow = rows?.[0];
    const storeRows = rows?.slice(1);

    return (
        <div className={styles.promotionStoreListRoot}>
            <div className={styles.wrapper}>
                {cta?.visible && cta?.url && cta?.label && (
                    <div className={styles.ctaWrapper}>
                        <a
                            href={applyLocaleToUrl(cta.url, locale)}
                            target={cta.openerType === 'New Tab' ? '_blank' : '_self'}
                            rel="noopener noreferrer"
                            aria-label={cta.ariaLabel}
                            className={cta.ctaType === 'Button' ? `${styles.articlePagesTextLink} ${styles.blackBgButton}` : `${styles.articleTextLink} ${styles.blackBgButton}`}
                        >
                            {cta.label}
                        </a>
                    </div>
                )}
                <section className="c-koh-ramadan-promotion-carousel">
                    <div className="koh-ramadan-promotion-container">
                        <div className="koh-ramadan-promotion-carousel-title">
                            {firstRow && (() => {
                                const rowSection = firstRow?.fields?.rowSection;
                                return (
                                    <table style={{ borderCollapse: 'collapse', border: 'none', width: '100%' }}>
                                        <tbody>
                                            <tr>
                                                {rowSection && rowSection.map((item, idx) => {
                                                    const { heading, imageUrl } = item?.fields || {};
                                                    return (
                                                        <td key={idx} style={{ width: `${Math.floor(100 / rowSection.length)}%`, padding: '0 5.4pt', verticalAlign: 'top' }}>
                                                            {imageUrl && (
                                                                <p style={{ display: "flex", justifyContent: "center", marginBottom: 0 }}>
                                                                    <img src={imageUrl} alt="" width={132} style={{ height: 'auto' }} />
                                                                </p>
                                                            )}
                                                            {heading && (
                                                                <p style={{ marginTop: '12px', marginRight: 0, marginBottom: 0, marginLeft: 0, lineHeight: 'normal', fontSize: '15px', fontFamily: '"Calibri",sans-serif', textAlign: 'center' }}>
                                                                    <strong>{renderRichText(heading, locale)}</strong>
                                                                </p>
                                                            )}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        </tbody>
                                    </table>
                                );
                            })()}
                        </div>
                        <div className="koh-projects-pages-container-banner">
                            <section className="c-koh-shopping-guide-carousel v-koh-article">
                                <div className="koh-carousel koh-theme-dark">
                                    <div className="koh-slide-collection"></div>
                                </div>
                            </section>
                        </div>
                    </div>
                </section>
                <section className="c-koh-ramadan-store-list">
                    <div className="koh-ramadan-store-list-container">
                        {storeRows && storeRows.map((row, rowIdx) => {
                            const rowSection = row?.fields?.rowSection;
                            const showLine = row?.fields?.showLine;
                            return (
                                <div key={rowIdx} className="row koh-ramadan-store-list-row">
                                    {rowSection && rowSection.map((item, idx) => {
                                        const { title, address, phone, phoneLink } = item?.fields || {};
                                        return (
                                            <div key={idx} className="col-lg-4 col-md-4 col-sm-4 col-xs-12 koh-ramadan-list-col" style={showLine === false ? { borderBottom: 'none' } : undefined}>
                                                {title && <p><strong>{title}</strong></p>}
                                                {address && <RichText text={address} />}
                                                {phone && (
                                                    <p>
                                                        <strong>Phone:</strong>{' '}
                                                        {phoneLink
                                                            ? <a href={phoneLink}>{phone}</a>
                                                            : phone
                                                        }
                                                    </p>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                </section>
            </div>
        </div>
    );
};

export default PromotionStoreList;